import React from 'react';
import toast from 'react-hot-toast';
import { useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { ArrowRightBtnIcon } from '../../common/components/icons/arrow-right-btn-icon.component copy';
import { MenuButton } from '../../settings/ui';
import { managementService } from '../service/management.service';
import { useThrottle } from '../../hooks/useThrottle';

interface IProps {
  className?: string;
}

export const PortalButton = ({ className = '' }: IProps) => {
  const { t } = useTranslation();
  const portalQuery = useMutation({
    mutationKey: ['portal'],
    mutationFn: () => managementService.getUserPortalUrl(),
    onSuccess: (url) => {
      window.location.href = url;
    },
    onError: () => {
      toast.error(t('management.portal.error'));
    }
  });

  const portalHandler = (): void => {
    portalQuery.mutate();
  };

  const throttledPortalHandler = useThrottle(portalHandler);

  return (
    <div className={`flex ${className}`} onClick={throttledPortalHandler}>
      <MenuButton
        text={t('management.portal.manageSubscriptions')}
        icon={<ArrowRightBtnIcon />}
        isReverse
        fill
        className="w-full min-w-0 md:w-[228px] md:min-w-fit text-sm md:text-base py-2 md:py-[10px] px-4 md:px-[20px] text-black"
      />
    </div>
  );
};
